import styled from 'styled-components'
import { t } from 'i18next'

const Layout = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
  min-height: 100vh;
  padding-top: 80px;
  background: var(--background);
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 700px;
  gap: 28px;
`

const Title = styled.h2`
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--text);
  text-align: center;
`

const Schedule = styled.p`
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  color: var(--text);
  text-align: center;
`

const TimeRange = styled.p`
  font-size: var(--text-lg);
  font-weight: var(--font-weight-medium);
  color: var(--text);
  text-align: center;
`

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px 24px;
  border-radius: var(--radius);
  background: var(--muted);
  gap: 8px;
`

const Memo = styled.p`
  font-size: var(--text-base);
  color: var(--text);
  text-align: center;
  line-height: 1.6;
`

const InspectImg = styled.img`
  width: 100%;
  height: auto;
  border-radius: var(--radius);
  object-fit: contain;
  object-position: center;

  &[src=''],
  &:not([src]) {
    display: none;
  }
`

/**
 * @param {{ inspection: Object }} props
 * @param {Object} props.inspection - SSE에서 수신한 점검 데이터
 */
export default function Inspection({ inspection }) {
  const isEmergency = inspection.inspec_yn === 'Y'
  const isPlanned = inspection.plan_inspec_yn === 'Y' && !isEmergency

  const formatTime = (time) => {
    if (!time) return '-'
    if (typeof time === 'string' && time.includes(':')) {
      const [h, m] = time.split(':')
      return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`
    }
    return time
  }

  return (
    <Layout>
      <Content>
        <Title>
          {isEmergency
            ? inspection.inspec_title || t('inspection.inspection_title')
            : t('inspection.inspection_message')}
        </Title>

        {isPlanned && (
          <>
            <Schedule>{t('inspection.inspection_date', { date: inspection.plan_inspec_week })}</Schedule>
            <TimeRange>
              {formatTime(inspection.plan_inspec_start)} ~ {formatTime(inspection.plan_inspec_end)}
            </TimeRange>
          </>
        )}

        <InfoBox>
          {isEmergency ? (
            <>
              <Memo>{inspection.inspec_memo}</Memo>
              {inspection.inspec_icon_file_uuid && (
                <InspectImg
                  src={process.env.REACT_APP_IMG_URL + inspection.inspec_icon_file_uuid}
                  alt={inspection.inspec_title}
                  onError={(e) => { e.target.style.display = 'none' }}
                />
              )}
            </>
          ) : (
            <>
              <Memo>{t('inspection.inspection_memo_message')}</Memo>
              <Memo>{t('inspection.inspection_memo_message2')}</Memo>
            </>
          )}
        </InfoBox>
      </Content>
    </Layout>
  )
}
